(function() {
  // Function to check the user's country and display a message if restricted
  function checkCountryAndDisplayMessage() {
    fetch('https://ipapi.co/json/')
      .then(response => response.json())
      .then(data => {
        const countryCode = data.country_code;
        const loadingDiv = document.querySelector('.hide');

        if (['CN', 'TW', 'HK'].includes(countryCode)) {
          if (loadingDiv) {
            document.body.innerHTML = '<h1>We\'re sorry, but this site is currently unavailable in your location.</h1><p>We apologize for any inconvenience.</p>';           
          }
          document.documentElement.style.visibility = 'visible';
        } else {
          if (loadingDiv) {
            loadingDiv.remove();
          }
          document.documentElement.style.visibility = 'visible';
        }
      })
      .catch(error => {
        console.error('Error fetching geolocation:', error);
        const loadingDiv = document.querySelector('.hide');
        if (loadingDiv) {
            loadingDiv.remove();
        }
        document.documentElement.style.visibility = 'visible';
      });
  }

  // Call the function when the DOM content is loaded
  document.addEventListener('DOMContentLoaded', checkCountryAndDisplayMessage);
})();